require('./_wks-define')('asyncIterator');



//////////////////
// WEBPACK FOOTER
// ./node_modules/_core-js@2.6.11@core-js/library/modules/es7.symbol.async-iterator.js
// module id = 82
// module chunks = 0